import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { Row, Column } from "react-foundation";
import "css/Installers.css";

import Slider from "react-slick";
import forwardArrow from "images/forward-arrow.svg";
import backArrow from "images/back-arrow.svg";
import SlickArrow from "../../components/SlickArrow";

import Logo from "components/Logo";
import { getGoogleReviews, saveInstallerChoice } from "actions";
import QuoteInstaller from "./../../components/QuoteInstaller";
import ThemeButton from "./../../components/ThemeButton";
import InputError from "../../components/InputError";
import { getProductIds } from "../../selectors";

const getProductsToSupply = (Installers) => {
    let productsToSupply = Installers.map((installer) => installer.productsSupplied);

    // flatten the array
    productsToSupply = [].concat(...productsToSupply);

    // remove duplicates
    productsToSupply = productsToSupply.filter(
        (product, index) =>
            productsToSupply.findIndex(({ productId }) => productId === product.productId) ===
            index,
    );

    // filter out anything without a productId
    productsToSupply = productsToSupply.filter((product) => !!product.productId);

    return productsToSupply;
};

class Installers extends Component {
    componentWillMount() {
        let googlePlaceIds = this.props.Installers.map((i) => i.googleReviewPlaceId);

        this.props.getGoogleReviews(googlePlaceIds);
    }

    onSubmit(values) {
        let installerIds = [];
        let selectedInstallers = [];

        if (values.installer1 && this.props.Installers[0]) {
            installerIds.push(this.props.Installers[0].guid);
            selectedInstallers.push(this.props.Installers[0]);
        }
        if (values.installer2 && this.props.Installers[1]) {
            installerIds.push(this.props.Installers[1].guid);
            selectedInstallers.push(this.props.Installers[1]);
        }
        if (values.installer3 && this.props.Installers[2]) {
            installerIds.push(this.props.Installers[2].guid);
            selectedInstallers.push(this.props.Installers[2]);
        }

        // Save full installer details to sessionStorage
        sessionStorage.setItem(
            "selectedInstallers",
            JSON.stringify(
                selectedInstallers.map((installer) => ({
                    guid: installer.guid,
                    companyName: installer.companyName,
                    address1: installer.address1,
                    address2: installer.address2,
                    address3: installer.address3,
                    address4: installer.address4,
                    county: installer.county,
                    postcode: installer.postcode,
                    landlinePhone: installer.landlinePhone,
                    websiteUrl: installer.websiteUrl,
                    distanceFromRetailCustomer: installer.distanceFromRetailCustomer,
                    productsSupplied: (installer.productsSupplied || []).map((p) => ({
                        productId: p.productId,
                        productName: p.productName,
                        productSuiteName: p.productSuiteName,
                    })),
                })),
            ),
        );

        this.props.saveInstallerChoice(installerIds, () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "tf_quotebuilder_installers_selected",
            });
            this.props.history.push("/GetQuote/ContactDetails");
        });
    }

    getColumnPushValue(installerCount) {
        switch (installerCount) {
            case 1:
                return 4;
            case 2:
                return 2;
            default:
                return 0;
        }
    }

    render() {
        const { Installers } = this.props;

        let productsToSupply = getProductsToSupply(Installers);

        return (
            <div className="Installers">
                <Logo topLeft={true} showForSmall={false} />

                <Row className="top-padding-page">
                    <Column small={9} medium={7} large={5} centerOnSmall>
                        <Logo topLeft={false} showForSmall={true} />

                        <h3>{"We’ve found your closest installers to " + this.props.Postcode}</h3>
                        <p>
                            {"You can  choose up to " +
                                Installers.length +
                                " installers to quote. "}
                        </p>
                    </Column>
                    <Column small={12}>
                        <form onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}>
                            <Row>
                                {Installers.length === 1 && (
                                    <Column small={0} medium={6 - Installers.length * 2}>
                                        &nbsp;
                                    </Column>
                                )}
                                {Installers.length === 1 &&
                                    Installers.map((installer, index) => (
                                        <Column isLast key={installer.guid} medium={4}>
                                            {installer && (
                                                <Field
                                                    name={"installer" + (index + 1)}
                                                    component={QuoteInstaller}
                                                    installer={installer}
                                                    productsToSupply={productsToSupply}
                                                    googleReviews={
                                                        this.props.GoogleReviews[
                                                            installer.googleReviewPlaceId
                                                        ] || []
                                                    }
                                                />
                                            )}
                                        </Column>
                                    ))}
                                {Installers.length > 1 && (
                                    <Slider
                                        className="InstallersSlider"
                                        dots={false}
                                        slidesToShow={3}
                                        centerPadding="0px"
                                        centerMode
                                        infinite
                                        initialSlide={1}
                                        nextArrow={<SlickArrow src={forwardArrow} />}
                                        prevArrow={<SlickArrow src={backArrow} />}
                                        arrows={Installers.length > 3}
                                        responsive={[
                                            {
                                                breakpoint: 639,
                                                settings: {
                                                    slidesToShow: 1,
                                                    arrows: Installers.length > 1,
                                                },
                                            },
                                        ]}
                                    >
                                        {Installers.map((installer, index) => (
                                            <Column isLast medium={4} key={installer.guid}>
                                                {installer && (
                                                    <Field
                                                        name={"installer" + (index + 1)}
                                                        component={QuoteInstaller}
                                                        installer={installer}
                                                        productsToSupply={productsToSupply}
                                                        googleReviews={
                                                            this.props.GoogleReviews[
                                                                installer.googleReviewPlaceId
                                                            ] || []
                                                        }
                                                    />
                                                )}
                                            </Column>
                                        ))}
                                    </Slider>
                                )}
                            </Row>

                            {this.props.invalid && (
                                <Row>
                                    <Column medium={8} large={6} centerOnMedium>
                                        <InputError
                                            metas={{
                                                error: this.props.error,
                                                touched: true,
                                            }}
                                        />
                                    </Column>
                                </Row>
                            )}

                            <div className="button-panel">
                                <ThemeButton>Quote Me</ThemeButton>
                            </div>
                        </form>
                    </Column>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        Installers: state.Installers,
        GoogleReviews: state.GoogleReviews,
        Postcode: state.CustomerDetails.postcode,
        ProductIds: getProductIds(state),
        // create an object with a properties "installerX" for each installer (with a value of true), where X is their index (1based)
        // so 2 installers would create {installer1:true,installer2:true}
        initialValues: state.Installers.map((installer, index) => index + 1).reduce(
            (acc, val) => ({ ...acc, ["installer" + val]: true }),
            {},
        ),
    };
};

const validate = (values, props) => {
    let errors = {};

    const selectedInstallerIndexes = [];
    for (const key in values) {
        if (values.hasOwnProperty(key)) {
            const value = values[key];
            if (value === true) {
                selectedInstallerIndexes.push(Number(key.substring("installer".length)) - 1);
            }
        }
    }

    // if we don't have at least 1 installer checked, add an error about it
    if (selectedInstallerIndexes.length === 0) {
        errors._error = "Please select at least 1 installer";
        return errors;
    }

    // check if every product has been selected. if not we're missing something and we need to let the user know

    const missingProductIds = [];

    props.ProductIds.forEach((productId) => {
        let found = false;

        for (let i = 0; i < selectedInstallerIndexes.length; i++) {
            const installerIndex = selectedInstallerIndexes[i];
            const installer = props.Installers[installerIndex];
            const { productsSupplied } = installer;

            if (productsSupplied.some((product) => product.productId === productId)) {
                found = true;
                break;
            }
        }

        if (found === false) {
            missingProductIds.push(productId);
        }
    });

    if (missingProductIds.length > 0) {
        const productsToSupply = getProductsToSupply(props.Installers);

        errors._error =
            "The installers you have selected do not offer all of your chosen products. You are missing an installer for the following: " +
            missingProductIds
                .map((id) => {
                    const missingProduct = productsToSupply.find(
                        ({ productId }) => productId === id,
                    );
                    return missingProduct && missingProduct.productName;
                })
                .join(", ");
    }

    return errors;
};

export default connect(mapStateToProps, { getGoogleReviews, saveInstallerChoice })(
    reduxForm({
        form: "installers",
        initialValues: {
            // these are handled in mapStateToProps as they are dynamic
        },
        validate,
    })(Installers),
);



// WEBPACK FOOTER //
// ./src/containers/QuoteForm/Installers.js